<section class="page">
  <header class="page-header">
    <div>
      <a routerLink="/support-tickets" class="back">← Support tickets</a>
      <h1>Support ticket detail</h1>
      <p>Review the request and update status</p>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  @if (loading()) {
    <div class="panel muted">Loading…</div>
  } @else {
    @if (ticket(); as row) {
      <div class="detail-grid">
        <div class="panel">
          <div class="panel-head">
            <h2>#{{ row.id }} · {{ row.topic_label || row.topic }}</h2>
            <span class="badge" [attr.data-status]="row.status">{{ statusLabel(row.status) }}</span>
          </div>
          <dl class="meta">
            <div>
              <dt>User</dt>
              <dd>
                {{ userLabel(row) }}
                <span class="muted"> · #{{ row.user_id }}</span>
                @if (row.user?.email) {
                  <div class="muted">{{ row.user?.email }}</div>
                }
              </dd>
            </div>
            <div><dt>Contact email</dt><dd>{{ row.email || '—' }}</dd></div>
            <div><dt>Topic</dt><dd>{{ row.topic_label || row.topic }}</dd></div>
            <div><dt>Created</dt><dd>{{ row.created_at ? (row.created_at | date: 'medium') : '—' }}</dd></div>
            <div><dt>Updated</dt><dd>{{ row.updated_at ? (row.updated_at | date: 'medium') : '—' }}</dd></div>
            <div><dt>Resolved</dt><dd>{{ row.resolved_at ? (row.resolved_at | date: 'medium') : '—' }}</dd></div>
          </dl>
        </div>

        <div class="panel">
          <h2>Update status</h2>
          <form class="update-form" (ngSubmit)="save()">
            <label>
              <span>Status</span>
              <select [(ngModel)]="editStatus" name="status" [disabled]="saving()">
                @for (s of statuses; track s) {
                  <option [value]="s">{{ statusLabel(s) }}</option>
                }
              </select>
            </label>
            <label>
              <span>Admin notes</span>
              <textarea
                [(ngModel)]="editNotes"
                name="admin_notes"
                rows="5"
                placeholder="Internal notes for the support team…"
                [disabled]="saving()"
              ></textarea>
            </label>
            <div class="actions">
              <button class="btn btn-primary" type="submit" [disabled]="saving()">
                {{ saving() ? 'Saving…' : 'Save changes' }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="panel message-panel">
        <h2>Message</h2>
        <p class="message-body">{{ row.message }}</p>
      </div>
    }
  }
</section>
